import { render, staticRenderFns } from "./SidemenuIcon.vue?vue&type=template&id=33b2010c&scoped=true&"
import script from "./SidemenuIcon.vue?vue&type=script&lang=js&"
export * from "./SidemenuIcon.vue?vue&type=script&lang=js&"
import style0 from "./SidemenuIcon.vue?vue&type=style&index=0&id=33b2010c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b2010c",
  null
  
)

export default component.exports